module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/candy-one-ea58e261bcbf1a0c1fbb96e82508a83a.png";